import { datadogRum, DefaultPrivacyLevel } from "@datadog/browser-rum";
import getEnv from "env";
import { BinaryChoice } from "utils/constants/common";

const {
  apiUrl,
  datadogRUMEnabled,
  datadogSite,
  datadogService,
  datadogApplicationId,
  datadogClientToken,
  datadogEnv,
  datadogAppVersion,
  datadogSessionSampleRate = "0",
  datadogReplaySampleRate = "0",
  datadogPrivacyLevel = DefaultPrivacyLevel.MASK,
} = getEnv();

if (datadogRUMEnabled === BinaryChoice.toBooleanString(BinaryChoice.Yes)) {
  datadogRum.init({
    applicationId: datadogApplicationId,
    clientToken: datadogClientToken,
    site: datadogSite,
    service: datadogService,
    env: datadogEnv,
    version: datadogAppVersion,
    sessionSampleRate: Number(datadogSessionSampleRate),
    sessionReplaySampleRate: Number(datadogReplaySampleRate),
    defaultPrivacyLevel: datadogPrivacyLevel as DefaultPrivacyLevel,
    enablePrivacyForActionName:
      datadogPrivacyLevel === DefaultPrivacyLevel.MASK,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    allowedTracingUrls: [apiUrl],
    beforeSend: (event) => !event.synthetics,
  });
}
